module.exports = __webpack_public_path__ + "img/programme5.11e17e68.png";